import {InjectionToken} from '@angular/core'
import {Observable} from 'rxjs'

// persists the language of the logged in user, provided per app by its customer service
export interface UserLanguageApi {
  getUserLang(): Observable<string>
  setUserLang(lang: string): Observable<unknown>
}

export const USER_LANGUAGE_API = new InjectionToken<UserLanguageApi>('UserLanguageApi')
